import { useMemo } from "react";
import { ENTITY_TYPES } from "../utils";
import { getDiscountColumns } from "../pages/DiscountAndPlanogram/DiscountTable/discountColumns";
import { getItemLevelColumns as getDiscountItemLevelColumns } from "../pages/DiscountAndPlanogram/DiscountTable/itemLevelColumns";

const useColumns = ({
  entityType,
  getProcessedRow = () => {},
  plannerNotes = [],
  retailerNotes = [],
  isDisplayItem = false,
}) => {
  const updatedColumns = useMemo(() => {
    let baseColumns = getDiscountColumns(getProcessedRow);
    const baseItemColumns = getDiscountItemLevelColumns(getProcessedRow);
    const itemColumns = [...baseColumns];
    switch (entityType) {
      case ENTITY_TYPES.discount:
        itemColumns.splice(5, 0, ...baseItemColumns);
        break;
      case ENTITY_TYPES.planogram:
        itemColumns.splice(9, 0, ...baseItemColumns);
        break;
      default: // do nothing
    }
    return isDisplayItem ? itemColumns : baseColumns;
  }, [isDisplayItem, entityType, getProcessedRow]);

  return {
    updatedColumns: updatedColumns,
  };
};

export default useColumns;
